import Box from './Box';

export default function Logo() {
	return (
		<Box name="logo">
			<svg
				enable-background="new 0 0 140 140"
				version="1.1"
				viewBox="0 0 140 140"
				xmlSpace="preserve"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clip-rule="evenodd" fill-rule="evenodd">
					<path
						d="m116.76 19.413-96.108-18.724c-11.061-2.159-21.002 6.809-19.985 18.038l9.662 105.6c0.966 10.543 11.111 17.527 21.281 14.683l95.498-26.622c8.209-2.312 13.371-10.265 12.099-18.697l-9.024-60.258c-1.095-7.165-6.305-12.626-13.423-14.023zm4.271 83.779h-16.349v-32.744c0-7.925-0.356-18.772-10.934-18.772-12.712 0-13.933 12.701-13.933 22.38v29.137h-16.347v-31.272c0-9.677-1.705-15.802-5.11-18.341-1.704-1.271-3.738-1.904-6.179-1.904-12.586 0-13.882 13.258-13.882 22.785v28.731h-16.298v-64.575h16.297v7.419c10.932-12.016 30.943-13.109 39.079 2.541 7.322-10.746 21.711-15.244 33.307-8.689 9.863 5.385 10.349 15.318 10.349 25.455v37.849z"
						fill="#C82027"
					/>
					<path
						d="m121.04 103.2h-16.349v-32.742c0-7.927-0.354-18.774-10.933-18.774-12.71 0-13.932 12.703-13.932 22.38v29.137h-16.347v-31.272c0-9.678-1.705-15.799-5.11-18.34-1.705-1.271-3.738-1.906-6.179-1.906-12.586 0-13.882 13.261-13.882 22.788v28.729h-16.298v-64.574h16.298v7.417c10.933-12.015 30.943-13.107 39.078 2.542 7.324-10.747 21.713-15.243 33.307-8.688 9.865 5.387 10.348 15.318 10.348 25.455v37.848z"
						fill="#fff"
					/>
				</g>
			</svg>
		</Box>
	);
}
